module.exports = __webpack_public_path__ + "static/media/comic2016.0534c6ab.png";